import React from 'react';
import EyeOpenIcon from '@atlaskit/icon/core/eye-open';
import LockUnlockedIcon from '@atlaskit/icon/core/lock-unlocked';
import ShareIcon from '@atlaskit/icon/core/share';
import ShowMoreHorizontalIcon from '@atlaskit/icon/core/show-more-horizontal';
import ThumbsUpIcon from '@atlaskit/icon/core/thumbs-up';
import { Inline } from '@atlaskit/primitives/compiled';
export var Actions = function Actions() {
  return /*#__PURE__*/React.createElement(Inline, {
    space: "space.150"
  }, /*#__PURE__*/React.createElement(LockUnlockedIcon, {
    label: "Lock Unlocked",
    color: "var(--ds-icon-subtle, #626F86)"
  }), /*#__PURE__*/React.createElement(EyeOpenIcon, {
    label: "Eye Open",
    color: "var(--ds-icon-subtle, #626F86)"
  }), /*#__PURE__*/React.createElement(ThumbsUpIcon, {
    label: "Thumbs Up",
    color: "var(--ds-icon-subtle, #626F86)"
  }), /*#__PURE__*/React.createElement(ShareIcon, {
    label: "Share",
    color: "var(--ds-icon-subtle, #626F86)"
  }), /*#__PURE__*/React.createElement(ShowMoreHorizontalIcon, {
    label: "Show More Horizontal",
    color: "var(--ds-icon-subtle, #626F86)"
  }));
};